// extracted by mini-css-extract-plugin
export default {"table":"Table-module--table--43af8"};